
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pirkimas/pristatymas",
      function () {
        return require("private-next-pages/pirkimas/pristatymas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pirkimas/pristatymas"])
      });
    }
  